var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            stroke: _vm.color,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            fill: "none"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"
            }
          }),
          _c("path", { attrs: { d: "M9 13a4.5 4.5 0 0 0 3-4" } }),
          _c("path", { attrs: { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5" } }),
          _c("path", { attrs: { d: "M3.477 10.896a4 4 0 0 1 .585-.396" } }),
          _c("path", { attrs: { d: "M6 18a4 4 0 0 1-1.967-.516" } }),
          _c("path", { attrs: { d: "M12 13h4" } }),
          _c("path", { attrs: { d: "M12 18h6a2 2 0 0 1 2 2v1" } }),
          _c("path", { attrs: { d: "M12 8h8" } }),
          _c("path", { attrs: { d: "M16 8V5a2 2 0 0 1 2-2" } }),
          _c("circle", {
            attrs: { cx: "16", cy: "13", r: ".5", fill: "none" }
          }),
          _c("circle", { attrs: { cx: "18", cy: "3", r: ".5", fill: "none" } }),
          _c("circle", {
            attrs: { cx: "20", cy: "21", r: ".5", fill: "none" }
          }),
          _c("circle", { attrs: { cx: "20", cy: "8", r: ".5", fill: "none" } })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }